<script setup lang="ts">
defineOptions({
	name: 'LampLightIcon',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:class="props.class"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			d="M7.0511 14.951C4.3163 12.2162 4.3163 7.78216 7.05111 5.04735C9.78592 2.31254 14.2199 2.31254 16.9547 5.04735C19.6895 7.78216 19.6895 12.2162 16.9547 14.951"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9 18.0025H15.0025"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 21.0037H14.0017"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
